// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2Gtbj","tab":"Header_tab__LAZ55","heading":"Header_heading__Tfp0G"};